// Layout.tsx
import React, { ReactNode } from 'react';
import Header from './Header';

interface LayoutProps {
  children: ReactNode;
}

export const Layout = ({ children }: LayoutProps) => {
  return (
    <div className="flex flex-col min-h-screen bg-[#f6f8f4]">
      <Header />
      <main className="flex-1 p-4">
        {children}
      </main>
      {/* <Footer /> */}
    </div>
  );
}
